__turbopack_context__.v({
  "barForm": "investor-alerts-form-module-scss-module__ZF7wyq__barForm",
  "barInput": "investor-alerts-form-module-scss-module__ZF7wyq__barInput",
  "barSubmit": "investor-alerts-form-module-scss-module__ZF7wyq__barSubmit",
  "feedbackError": "investor-alerts-form-module-scss-module__ZF7wyq__feedbackError",
  "feedbackSuccess": "investor-alerts-form-module-scss-module__ZF7wyq__feedbackSuccess",
  "panelEmailRow": "investor-alerts-form-module-scss-module__ZF7wyq__panelEmailRow",
  "panelForm": "investor-alerts-form-module-scss-module__ZF7wyq__panelForm",
  "panelInput": "investor-alerts-form-module-scss-module__ZF7wyq__panelInput",
  "panelLabel": "investor-alerts-form-module-scss-module__ZF7wyq__panelLabel",
  "panelNameRow": "investor-alerts-form-module-scss-module__ZF7wyq__panelNameRow",
  "panelSubmit": "investor-alerts-form-module-scss-module__ZF7wyq__panelSubmit",
});
